import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { ANALYTICS_SOURCE } from '../src/BulkSpacePermissionsPage.tsx';

export const BulkSpacePermissionsPage: LoadableType<Omit<unknown, 'flags'>> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BulkSpacePermissionsPage" */ '../src/BulkSpacePermissionsPage.tsx'
			)
		).BulkSpacePermissionsPage,
	name: 'BulkSpacePermissionsPage',
});
